import OtherExplanations from './OtherExplanations';

export default OtherExplanations;
